import {type QEPNotification} from '../qep-system';

type Type = 'alert' | 'success' | 'warning' | 'error' | 'info' | 'information';

export type NotificationType = {
  builder: (type: Type, text: string) => string;
  default_timeout: number;
  local: {
    error: NotificationMethod<any, any>;
    success: NotificationMethod<any, any>;
    warning: NotificationMethod<any, any>;
    info: NotificationMethod<any, any>;
  };
  notify: (parameters: QEPNotification<any>) => any;
};

export type NotificationMethod<T, U> = (parameters: T) => U;
